// extracted by mini-css-extract-plugin
module.exports = {"container":"changeBalanceDialog_container__39W8u","detail":"changeBalanceDialog_detail__Iprvh","message":"changeBalanceDialog_message__2sfPG"};